import React, { useEffect, useRef, useState } from "react";

import {
  Badge,
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Rating,
} from "@mui/material";
//import ReusableSwitch from "../../Switch/ReusableSwitch";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import jsonData from "./Product/item.json";

import Layout from "../../components/Layout/Frontend/Layout";
//  import { setShopCurrency } from "../../redux/slice/ShopSlice";0
import PaginationComponent from "../../components/Backend/PaginationComponent";
import { FetchRecordingCourseFrontendAsync } from "../../redux/thunk/RecordingCourse";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReadOnlyQuill from "../../components/Backend/Admin/Posts/ReadOnlyQuill";

const CourseCard = ({ item }) => {
  const navigate = useNavigate();
  const country = localStorage.getItem("country") || "USD";

  let calculateFees = (country, oversea_fees) => {
    const conversionRates = {
      USD: 0.67,
      SGD: 0.9,
      THB: 24.63,
      NZD: 1.09,
    };

    return conversionRates[country]
      ? (oversea_fees * conversionRates[country]).toFixed(2)
      : oversea_fees;
  };

  return (
    <Card
      sx={{
        display: "flex",
        p: 2,
        boxShadow: 2,
        width: "100%",
        borderRadius: 2,
      }}
    >
      {/* Course Image */}
      <CardMedia
        component="img"
        src={
          item.image_file
            ? `${
                process.env.REACT_APP_BACKEND_URL +
                "storage/" +
                item?.image_file
              }`
            : `${process.env.REACT_APP_FRONTEND_URL}Image/AigmaLogo.png` // Default image
        }
        alt="Course Thumbnail"
        sx={{
          width: "30%",
          height: "200px",
          borderRadius: 1,
          objectFit: "cover",
        }}
      />

      {/* Course Details */}
      <CardContent sx={{ flex: 1, pl: 2 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1,
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            {item.title}
          </Typography>
          <Button
            sx={{
              background: "#005aa7",
              borderRadius: "0.5rem",
              boxShadow: 5,
              color: "white",
              padding: 1,
              "&:hover": {
                backgroundColor: "#66a6ff",
                color: "#000",
              },
              ml: 1,
            }}
            onClick={() => navigate("/recording-course/" + item.id)}
          >
            View Detail
            {/* <Badge color="error"  max={99}>
                <VisibilityIcon />
              </Badge> */}
          </Button>
        </Box>
        <Typography variant="body2" color="text.secondary" mt={0.5}>
          {item.sub_title}
        </Typography>

        <Typography variant="body2" color="text.secondary" mt={1}>
          {item.instructor_info}
        </Typography>

        {/* Rating */}
        <Box display="flex" alignItems="center" mt={1}>
          {/* <Typography variant="body2" fontWeight="bold">
            5.0
          </Typography>
          <Rating value={5} precision={0.5} readOnly sx={{ ml: 0.5 }} /> */}
          {/* <Typography variant="body2" color="text.secondary" sx={{ ml: 0.5 }}>
            (2)
          </Typography> */}
        </Box>

        {/* Course Info */}
        <Typography variant="body2" color="text.secondary" mt={1}>
          {/* 1 total hour • 7 lectures • All Levels */}
          {item.course_content}
          {/* <ReadOnlyQuill
            delta={item.course_includes}
            quillClass={"front-rc"}
          /> */}
        </Typography>

        {/* Price */}
        <Box display="flex" alignItems="center" mt={1}>
          <Typography variant="h6" fontWeight="bold">
            {country == "MMK"
              ? item.fees
              : calculateFees(country, item.oversea_fees)}{" "}
            {country}
          </Typography>
          {/* <Typography variant="body2" color="text.secondary" sx={{ textDecoration: "line-through", ml: 1 }}>
            ฿599
          </Typography> */}
        </Box>
      </CardContent>
    </Card>
  );
};

function RecordingCourse() {
  const [bannerLoading, setBannerLoading] = useState(true);
  const { userCart } = useSelector((state) => state.user);
  //const [selectType, setSelectType] = useState("Wire");
  const [showPlan, setShowPlan] = useState("");
  const { country } = useSelector((state) => state.user);

  //const [imageStyle, setImageStyle] = useState({});

  //const [wireHeadphoneData, setWireHeadphoneData] = useState([]);
  //const [wirelessHeadphoneData, setWirelessHeadphoneData] = useState([]);
  //const [dataLoading, setDataLoading] = useState(true);
  const { recordingCourseFrontend, recordingCourseFrontendStatus } =
    useSelector((state) => state.recordingCourse);

  console.log(recordingCourseFrontend, "<<<recordingCourseFrontend");
  const imgRef = useRef(null);
  const navigate = useNavigate();
  const handleImageLoad = (e) => {
    const { naturalWidth, naturalHeight } = e.target;

    if (naturalWidth >= naturalHeight) {
      // Landscape orientation
      console.log("width greater");
      //setImageStyle({ width: "100%", height: "auto" });
    } else {
      console.log("height greater");
      // Portrait orientation
      //setImageStyle({ height: "100%", width: "auto" });
    }
  };

  useEffect(() => {
    // Check if the image is already loaded

    if (imgRef.current && imgRef.current.complete) {
      setBannerLoading(false);
    }
  }, []);

  const [page, setPage] = useState(1);

  const dispatch = useDispatch();
  const path = "recording-course-frontend?page=" + page;
  useEffect(() => {
    dispatch(FetchRecordingCourseFrontendAsync({ path: path }));
  }, [path, dispatch]);

  let handleChange = (event, p) => {
    setPage(p);
  };

  const [currency, setCurrency] = React.useState("");

  const handleCurrencyChange = (event) => {
    setCurrency(event.target.value);
    // dispatch(setShopCurrency(event.target.value));
  };

  return (
    <Layout bgColor="#093E7C">
      <Box
        sx={{
          width: "100%",
          // height: "70vh",
          // backgroundImage: `url(${process.env.REACT_APP_FRONTEND_URL}Image/subscription_banner.png)`,
          // backgroundPosition: "center",
          // backgroundSize: "cover",
          // backgroundAttachment: "fixed",
          // backgroundBlendMode: "overlay",
        }}
      >
        {bannerLoading && (
          <Box
            sx={{
              minHeight: "60vh",
              maxHeight: "800px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress size={50} />
          </Box>
        )}
        <img
          ref={imgRef}
          src={`${process.env.REACT_APP_FRONTEND_URL}Image/vc_banner.png`}
          alt="subscription-banner"
          style={{
            width: "100%",
            display: bannerLoading ? "none" : "block",
          }}
          onLoad={(e) => {
            handleImageLoad(e);
            setBannerLoading(false);
          }}
        />
      </Box>
      <Box sx={{ backgroundColor: "#093E7C", height: "auto", pb: "5rem" }}>
        <Box
          sx={{
            width: "90vw",
            maxWidth: "1350px",
            margin: "0 auto",
            pt: "2rem",
          }}
        >
          <Box>
            <Box sx={{}}>
              {/* <Typography
                component="h1"
                sx={{ fontSize: "2.5rem", fontWeight: "bold" }}
              >
                Shop
              </Typography> */}
            </Box>
            <Box
              sx={{
                display: "flex",
                mb: 5,
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                maxWidth: "1600px",
                margin: "0 auto",
              }}
            >
              {/* <Box
                sx={{
                  width: {
                    xs: "50%",
                    sm: "30%",
                    md: "20%",
                  },
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Shop Currency
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    // value={shopCurrency}
                    label="currency"
                    onChange={handleCurrencyChange}
                    sx={{
                      bgcolor: "white",
                      boxShadow: "0 0 0 2px gray",
                      "&.MuiPaper-root": {
                        bgcolor: "red",
                      },
                    }}
                  >
                    <MenuItem value={"SGD"}>Singapore</MenuItem>
                    <MenuItem value={"AUD"}>Australia</MenuItem>
                    <MenuItem value={"THB"}>Thailand</MenuItem>
                     <MenuItem value={"NZD"}>New Zealand</MenuItem>
                    <MenuItem value={"MMK"}>Myanmar</MenuItem>
                  </Select>
                </FormControl>
              </Box> 
               
              <Box sx={{ display: "flex", alignItems: "center" }}>
                 

                <Button
                  sx={{
                    background: "white",
                    borderRadius: "0.5rem",
                    boxShadow: 5,
                    padding: 1,
                    ml: 1,
                  }}
                  onClick={() => navigate("/pte-shop/cart")}
                >
                  <Badge color="error" badgeContent={userCart?.length} max={99}>
                    <VisibilityIcon />
                  </Badge>
                </Button>
              </Box>*/}
            </Box>
            <Box sx={{ py: 2 }}>
              <Typography
                variant="h4"
                fontWeight={"bold"}
                sx={{ textAlign: "center", color: "white", pb: 6 }}
              >
                Video Courses
              </Typography>

              <Box
                sx={{
                  display: "flex",

                  justifyContent: "center",
                  flexWrap: "wrap",
                  gap: 2,
                  alignItems: "center",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                {recordingCourseFrontendStatus === "succeeded" &&
                  recordingCourseFrontend.data.map((item) => (
                    <Box sx={{ display: "flex", width: "80%" }}>
                      <CourseCard item={item} name={item.name} key={item.id} />
                    </Box>
                  ))}

                {recordingCourseFrontendStatus === "succeeded" &&
                  recordingCourseFrontend?.data?.length == 0 && (
                    <Typography variant="h5" sx={{ my: 2, color: "white" }}>
                      Nothing to show ...
                    </Typography>
                  )}

                {recordingCourseFrontendStatus === "failed" && (
                  <Box>
                    Failed to get products .Please retry after some times.
                  </Box>
                )}
              </Box>

              <Box
                sx={{
                  mx: 1.5,
                  my: 2.5,
                  width: "90%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <PaginationComponent
                  page={page}
                  size={"medium"}
                  totalPage={recordingCourseFrontend?.last_page}
                  handleChange={handleChange}
                ></PaginationComponent>
              </Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={{
                borderRadius: "1rem",

                my: "5rem",
                boxShadow: 4,
              }}
            >
              <img
                src={`${process.env.REACT_APP_FRONTEND_URL}Image/Get-Discount Buy-Aigma-Plans-2.png`}
                alt={"discount-bg"}
                style={{ width: "100%", height: "auto", minHeight: "20vh" }}
              />
              {/* <Box
                sx={{
                  width: {
                    xs: "100%",
                    md: "50%",
                  },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    color: "rgb(18 ,82,166)",
                    fontWeight: "bolder",
                    mb: "2rem",
                  }}
                >
                  Get <span style={{ color: "red" }}>5%</span> Discount <br />
                  Buy Aigma Plans
                </Typography>
                <Button
                  variant="contained"
                  size="lg"
                  sx={{ fontSize: "1.4rem" }}
                >
                  Shop Now
                </Button>
              </Box> */}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{ background: "rgb(247,245,253)" }}>
        <Box
          sx={{
            width: "100%",
            height: "70vh",
            maxHeight: "800px",
            backgroundImage: `url(${process.env.REACT_APP_FRONTEND_URL}Image/headphone-bg.png)`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundAttachment: "fixed",
            backgroundBlendMode: "overlay",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h2"
              sx={{
                color: "white",
                fontWeight: "bolder",
                textTransform: "capitalize",
                textAlign: "center",
                mb: "2rem",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              }}
            >
              Explore Your Headphone
              <br /> With Aigma
            </Typography>
            <Button
              variant="contained"
              sx={{ fontSize: "1.4rem", color: "yellow" }}
            >
              Contact Now
            </Button>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
}

export default RecordingCourse;
